import { render, staticRenderFns } from "./trainingshare.vue?vue&type=template&id=6e79203f&scoped=true&"
import script from "./trainingshare.vue?vue&type=script&lang=js&"
export * from "./trainingshare.vue?vue&type=script&lang=js&"
import style0 from "./trainingshare.vue?vue&type=style&index=0&id=6e79203f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e79203f",
  null
  
)

export default component.exports